module.exports = __webpack_public_path__ + "img/firend.48fc6d22.png";